var _circle, _circle2, _g, _circle3, _path, _circle4, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEscore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 7,
    fill: "#6CE9A6"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1293_15745",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 14
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 7,
    fill: "#6CE9A6"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1293_15745)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1293_15745)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5 7H-3.20833L4.37501 17.5L16.0417 14L17.5 7Z",
    fill: "#32D583"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 5.25,
    fill: "#12B76A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M6.59888 3.40284C6.57048 3.14814 6.7543 2.91585 7.01058 2.91651C7.7583 2.91844 8.49441 3.12578 9.13666 3.52014C9.7789 3.9145 10.2968 4.47719 10.6368 5.14314C10.7533 5.3714 10.6293 5.64042 10.3893 5.73031C10.1493 5.82021 9.88479 5.69626 9.7607 5.47203C9.4984 4.99807 9.11708 4.59719 8.65103 4.31102C8.18498 4.02485 7.65496 3.86613 7.11361 3.84662C6.8575 3.83739 6.62728 3.65754 6.59888 3.40284Z",
    fill: "#FFFCF5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1293_15745",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 12,
    height: 12
  }, _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 5.25,
    fill: "#FEC84B"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1293_15745)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.08449 5.80877L6.05088 8.71805C5.94853 8.86447 5.89735 8.93768 5.82977 8.97369C5.77031 9.00536 5.70236 9.0174 5.63565 9.00808C5.55981 8.99748 5.4866 8.94631 5.34018 8.84396L4.32812 8.13653C4.18171 8.03418 4.1085 7.983 4.03265 7.97241C3.96594 7.96308 3.89799 7.97512 3.83853 8.0068C3.77095 8.0428 3.71977 8.11601 3.61742 8.26243L2.35915 10.0625M8.08449 5.80877L5.88587 6.19827M8.08449 5.80877L8.47399 8.00739",
    stroke: "url(#paint0_linear_1293_15745)",
    strokeWidth: 1.05882,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_1293_15745)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2292 8.50216L11.3156 8.4329L11.3696 8.16675L11.4115 8.42196L11.5208 8.45841L11.4115 8.53133L11.3696 8.75008L11.3385 8.53133L11.2292 8.50216Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_1293_15745)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.91666 7.08758L10.0895 6.94906L10.1975 6.41675L10.2812 6.92716L10.5 7.00008L10.2812 7.14591L10.1975 7.58341L10.1354 7.14591L9.91666 7.08758Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1293_15745",
    x: -4.97303,
    y: 5.23529,
    width: 24.2377,
    height: 14.0294,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.882353,
    result: "effect1_foregroundBlur_1293_15745"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1293_15745",
    x: 11.1703,
    y: 8.10792,
    width: 0.409315,
    height: 0.700899,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0294118,
    result: "effect1_foregroundBlur_1293_15745"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_1293_15745",
    x: 9.85784,
    y: 6.35792,
    width: 0.700979,
    height: 1.2844,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0294118,
    result: "effect1_foregroundBlur_1293_15745"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1293_15745",
    x1: 7.86192,
    y1: 4.55242,
    x2: 3.0907,
    y2: 9.80334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489583,
    stopColor: "white",
    stopOpacity: 0.66
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEscore);
export default __webpack_public_path__ + "static/media/icon-escore.9a0312506e456795488d6d3ec19c0e532dddb65d8114851bafd898a820b45dd3.svg";
export { ForwardRef as ReactComponent };